import {Modals} from "../Modals";
import Utilities from "../Utilities";
import {Dropdowns} from "../Dropdowns/Dropdowns";

export class FormOnSuccess {
    static categoryTreeCreate(form, data)
    {
        const tree = $("[data-categoryTree]", $(form).closest('body')).jstree(true), pNode = tree.get_node($(':input[name="parent_id"]', form).val()) || '#';

        const newNode = {
            id: data.session.category.id,
            text: $('input[name="name"]', form).val()
        };

        tree.create_node( pNode, newNode);
    }

    static categoryTreeEdit(form, data)
    {
        const tree = $("[data-categoryTree]", $(form).closest('body')).jstree(true), node = tree.get_selected();

        if($('input[name="name"]', form).val() != node.text)
            tree.rename_node(node, $('input[name="name"]', form).val())
    }

    static customerCreateSelectize(form, data)
    {
        let sApi = $('#inputCustomer')[0].selectize;
        sApi.addOption(data.session.customer);
        sApi.addItem(data.session.customer.id);
        sApi.setValue(data.session.customer.id);
        $('#overlay').remove()
    }

    static billingAddressCreateSelectize(form, data)
    {
        let sApi = $('#inputBilling')[0].selectize;
        sApi.enable();
        sApi.addOption(data.session.address);
        sApi.addItem(data.session.address.id);
        sApi.setValue(data.session.address.id);

        console.log(data.session)


        if($('#inputShipping').length > 0){
            let sApi = $('#inputShipping')[0].selectize;
            sApi.addOption(data.session.address);
            sApi.addItem(data.session.address.id);
        }

    }

    static billingAddressEditSelectize(form, data)
    {
        let bApi = $('#inputBilling')[0].selectize;
        bApi.clear();

        data.session.address.address_string = data.session.address.address.address_string

        bApi.removeOption(data.session.address.id);
        bApi.addOption(data.session.address);
        bApi.addItem(data.session.address.id);
        bApi.setValue(data.session.address.id);

        let addressesSame = $('#inputShipping').val() == $('#inputBilling').val()

        let sApi = $('#inputShipping')[0].selectize;
        sApi.removeOption(data.session.address.id);
        sApi.addOption(data.session.address);

        if(addressesSame){
            sApi.addItem(data.session.address.id);
            bApi.setValue(data.session.address.id);
        }

    }

    static shippingAddressCreateSelectize(form, data)
    {
        let sApi = $('#inputShipping')[0].selectize;
        sApi.addOption(data.session.address);
        sApi.addItem(data.session.address.id);
        sApi.setValue(data.session.address.id);

        if($('#inputBilling').length > 0){
            let sApi = $('#inputBilling')[0].selectize;
            sApi.removeOption(data.session.address.id);
            sApi.addOption(data.session.address);
        }
    }

    static shippingAddressEditSelectize(form, data)
    {
        let sApi = $('#inputShipping')[0].selectize;
        sApi.clear();

        data.session.address.address_string = data.session.address.address.address_string

        sApi.removeOption(data.session.address.id);
        sApi.addOption(data.session.address);
        sApi.addItem(data.session.address.id);
        sApi.setValue(data.session.address.id);

        let addressesSame = $('#inputShipping').val() == $('#inputBilling').val()

        let bApi = $('#inputBilling')[0].selectize;
        bApi.removeOption(data.session.address.id);
        bApi.addOption(data.session.address);

        if(addressesSame){
            bApi.clear();
            bApi.addItem(data.session.address.id);
        }

    }

    static supplierCreateSelectize(form, data)
    {
        let sApi;
        if (form.is('[data-selectize-name]'))
            sApi = $("[name='"+form.attr('data-selectize-name')+"']")[0].selectize;
        else
            sApi = $('select.inputSupplier').last()[0].selectize;

        Dropdowns.clearPreloadCache();

        sApi.addOption(data.session.supplier);
        sApi.addItem(data.session.supplier.id);
        sApi.setValue(data.session.supplier.id);
    }
}
